/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
export const UPDATE_ORDER = 'MFE/MBP-CHECKOUT/UPDATE_ORDER';
export const REFRESH_CART_DATA = 'MFE/MBP-CHECKOUT/REFRESH_CART_DATA';
